import {
  CURRENT_STATE_SORT_ADDRESS,
  CURRENT_STATE_SORT_BACKUP_BATTERY,
  CURRENT_STATE_SORT_DATE,
  CURRENT_STATE_SORT_HOUR_METER,
  CURRENT_STATE_SORT_IDENTIFIER,
  CURRENT_STATE_SORT_LABEL,
  CURRENT_STATE_SORT_LICENSE_PLATE,
  CURRENT_STATE_SORT_ODOMETER,
  CURRENT_STATE_SORT_POWERSOURCE,
  CURRENT_STATE_SORT_SATELLITES,
  CURRENT_STATE_SORT_SIGNAL,
  CURRENT_STATE_SORT_SPEED,
  CURRENT_STATE_SORT_STATUS,
  CURRENT_STATE_SORT_TYPE,
} from '../constants/currentStates';
import { Asset } from './asset';
import { DeviceGpsType } from './device';
import { GeoPoint } from './geoModels';

export interface HistoricState {
  asset: Asset;
  engine_ignition_status: boolean;
  gnss_vehicle_mileage: number;
  position_direction: number;
  position_latitude: number;
  position_longitude: number;
  timestamp: string;
  geoReference: string;
  position_speed: number;
  notificationType: number;
  operationalState?: OperationalState;
  sleepModeStatus?: boolean;
}

export interface AssetState extends HistoricState {}

export interface HistoricTelemetry {
  asset: Asset;
  engine_ignition_status: boolean;
  gnss_vehicle_mileage: number;
  position_direction: number;
  position_latitude: number;
  position_longitude: number;
  timestamp: number;
  geoReference: string;
  position_speed: number;
  can_engine_rpm: number;
  operationalState: OperationalStateStatus;
  idle_status: boolean;
  total_fuel_consumed: number;
}

export interface HistoricDoorState {
  asset: Asset;
  position_direction: number;
  position_latitude: number;
  position_longitude: number;
  timestamp: number;
  geoReference: string;
  position_speed: number;
}

export enum OperationalStateStatus {
  off = 'Apagado',
  on = 'Encendido',
  movement = 'En movimiento',
  inactive = 'Inactivo',
  ralenti = 'Ralenty',
}

export interface DtcRecord {
  code?: string;
  description?: string;
  standard?: string;
  status?: string;
  timestamp?: number;
}

export interface OperationalState {
  currentStatus?: OperationalStateStatus;
  lastStatusChange?: number;
  duration?: number;
}

export interface CurrentState extends HistoricState {
  engine_motorhours: number;
  battery_percentage: number;
  created: string;
  external_powersource_voltage: number;
  gsm_signal_dbm: number;
  ident: string;
  lastModified: string;
  point: GeoPoint;
  position_satellites: number;
  positionType: string;
  power_on_status: boolean;
  requiresAttention?: number;
  canEngineRpm?: number;
  canDtc?: DtcRecord[];
  totalFuelConsumed?: number;
  deviceGpsType?: DeviceGpsType;
}

export type CameraState = CurrentState & {
  deviceGpsType: DeviceGpsType.camera;
};

export interface MapCurrentState {
  ident: string;
  assetId: string;
  label: string;
  point: GeoPoint;
}

export type CurrentStateSortOption =
  | typeof CURRENT_STATE_SORT_LICENSE_PLATE
  | typeof CURRENT_STATE_SORT_LABEL
  | typeof CURRENT_STATE_SORT_DATE
  | typeof CURRENT_STATE_SORT_ODOMETER
  | typeof CURRENT_STATE_SORT_HOUR_METER
  | typeof CURRENT_STATE_SORT_STATUS
  | typeof CURRENT_STATE_SORT_SPEED
  | typeof CURRENT_STATE_SORT_BACKUP_BATTERY
  | typeof CURRENT_STATE_SORT_POWERSOURCE
  | typeof CURRENT_STATE_SORT_SATELLITES
  | typeof CURRENT_STATE_SORT_SIGNAL
  | typeof CURRENT_STATE_SORT_TYPE
  | typeof CURRENT_STATE_SORT_ADDRESS
  | typeof CURRENT_STATE_SORT_IDENTIFIER;

export enum CurrentStateAction {
  info = 'info',
  command = 'command',
  audioCommand = 'audioCommand',
  historicReport = 'historicReport',
  dtcList = 'dtcList',
}

export interface HistoricAlarm {
  ident: string;
  alarmType: number;
  gpsLat: number;
  gpsLng: number;
  gpsAngle: number;
  gpsSpeed: number;
  gpsTime: number;
  assetId: string;
}
